export default __webpack_public_path__ + "static/media/aggrement_mobile.33722c0c.png";